// extracted by mini-css-extract-plugin
module.exports = {"MainDiv":"ControlPanelPage_MainDiv__zyAwV","MyTable":"ControlPanelPage_MyTable__2hvSF"};